import { useState, useEffect } from 'react';
import { useInStockProductVariant } from '@app/pdp/hooks/useInStockProductVariant';
import type { SelectedVariantKeys, VariantValue } from '@libs/algolia';
import { ALGOLIA_COLOR_MAP } from '@libs/algolia';
import { clsx, usePageLayout } from '@libs/common-next';
import { RadioField } from '@petsmart-ui/sparky';

type ColorToggleItemProps = {
    variantKey: SelectedVariantKeys;
} & Omit<VariantValue, 'key'>;

export default function ColorToggleItem({
    variantKey,
    value,
    display,
}: ColorToggleItemProps) {
    const [inStock, setInStock] = useState(true);
    const { selectedStore } = usePageLayout();
    const stock = useInStockProductVariant(variantKey, value, selectedStore);

    useEffect(() => {
        setInStock(stock);
    }, [stock]);

    const colorClassName = clsx(
        'c-color-toggle__color',
        value === ALGOLIA_COLOR_MAP.White && 'color-toggle__with-border'
    );

    const [backgroundColor, backgroundColorSecondary] = value.split(',');
    const background = backgroundColorSecondary
        ? `linear-gradient(to bottom, ${backgroundColor} 0%, ${backgroundColorSecondary} 100%)`
        : undefined;

    return (
        <RadioField.Item
            diagonalStrikethrough={!inStock}
            value={value}
            text={
                <>
                    <div
                        className={colorClassName}
                        style={{ background, backgroundColor }}
                    />
                    <div className="sparky-u-is-vishidden">
                        {display ?? value}
                    </div>
                </>
            }
            data-testid={`radio-${display}`}
        />
    );
}
